<div class="h-full w-full flex flex-col items-center justify-center p-4 sm:p-8 overflow-y-auto">
  <div class="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center relative overflow-hidden">
    
    <!-- Full screen loading overlay -->
    @if(loading) {
      <div class="absolute inset-0 bg-white/90 z-50 flex flex-col items-center justify-center backdrop-blur-sm transition-all duration-300">
        <svg class="animate-spin h-12 w-12 text-blue-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
        <p class="text-blue-800 font-bold text-lg animate-pulse">Conectando con Zoho...</p>
        <p class="text-slate-500 text-sm mt-1">Saliendo de la aplicación para autorizar.</p>
      </div>
    }

    <div class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 to-indigo-600"></div>
    
    <div class="mb-6 flex justify-center mt-2">
      <div class="h-20 w-20 bg-blue-50 rounded-full flex items-center justify-center">
        <svg class="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
        </svg>
      </div>
    </div>
    
    <h2 class="text-2xl font-bold text-gray-800 mb-3">Vincula tu cuenta de Zoho</h2>
    
    <p class="text-gray-600 mb-6 text-sm">
      Para poder enviar notas, programar llamadas y asignar tareas a tu nombre oficial, es necesario conectar tu sesión actual con nuestro entorno de Zoho CRM.
    </p>

    <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6 text-left text-sm text-yellow-800 rounded">
      <p class="font-bold flex items-center gap-1">
        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"></path></svg>
        Regla de Seguridad
      </p>
      <p class="mt-1">Debes autorizar con el MISMO correo con el que entraste al CRM WhatsApp. Zoho bloqueará cualquier otro correo.</p>
    </div>

    <!-- Mensaje de error si la redirección falla -->
    @if(errorMessage) {
      <div class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-6 text-sm flex items-start text-left">
        <svg class="w-5 h-5 mr-1.5 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path></svg>
        <span>{{ errorMessage }}</span>
      </div>
    }

    <button 
      (click)="linkZoho()"
      [disabled]="loading"
      class="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg shadow transition-colors cursor-pointer disabled:bg-blue-300 disabled:cursor-not-allowed">
      @if(!loading) {
        <ng-container>
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
          Autorizar con Zoho CRM
        </ng-container>
      }
      @if(loading) {
        <ng-container>
          <svg class="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
          Redirigiendo a Zoho...
        </ng-container>
      }
    </button>
  </div>
</div>
